/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "./high-contrast-styles.css";
import { compose } from "redux";
import {injectIntl, FormattedMessage } from "react-intl";


const HighContrast = (props) => {
  const { intl } = props;

  const [contrast, setContrast] = useState(false);

  const handleContrast = () => {
    setContrast((contrast) => !contrast);
    const divRoot = document.getElementById("root");

    contrast
      ? divRoot.classList.remove("high-contrast")
      : divRoot.classList.add("high-contrast");
  };

  return (
    <section aria-label={`${intl.formatMessage({
      id: "LABELS.ALTO_CONTRASTE",
    })}`}>
      <button
        className="high-contrast__content"
        onClick={handleContrast}
        role="switch"
        aria-checked={contrast === true}
        tabIndex={0}
        title={intl.formatMessage({
          id: "LABELS.ALTO_CONTRASTE",
        })}
        aria-label={`${intl.formatMessage({
          id: "LABELS.ALTO_CONTRASTE",
        })}`}
      >
        <i className="material-icons high-contrast__icon" aria-hidden="true">
          contrast
        </i>
        <span className="high-contrast__title">
          <FormattedMessage id="LABELS.ALTO_CONTRASTE" />
        </span>
      </button>
    </section>
  );
};

export default compose(injectIntl) (HighContrast);
